module.exports = __webpack_public_path__ + "static/assets/725036c2acc1166bca683ab184b224e2.ttf";